export const FETCH_LEX_RECLEARN = 'FETCH_LEX_RECLEARN';
export const LEX_RECLEARN_SUCCESS = 'LEX_RECLEARN_SUCCESS';
export const LEX_RECLEARN_ERROR = 'LEX_RECLEARN_ERROR';
